var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-text"},[_c('textarea',{attrs:{"placeholder":"Écrire ici...","maxlength":"22"},on:{"input":_vm.textareaInput,"keypress":_vm.textareaKeyPress}})])}
var staticRenderFns = []

export { render, staticRenderFns }